import { render } from "./copiableText.vue?vue&type=template&id=c2e00122&scoped=true"
import script from "./copiableText.vue?vue&type=script&lang=js"
export * from "./copiableText.vue?vue&type=script&lang=js"

import "./copiableText.vue?vue&type=style&index=0&id=c2e00122&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/emblematic.es/tour.emblematic.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e00122"]])

export default __exports__